import type { RouteContext } from '@townsquare/router/routing-types';

import Loadable from '@townsquare/loadable';
import { teamsDirectoryRoute } from '@townsquare/routes/teams-directory-view';
import { tqlExplainerResource } from '@townsquare/tql/resource';

import { cleanUpTeamsSkillNudgeResource } from './resources/clean-up-teams-skill-nudge';
import { teamDirectoryResource } from './resources/team-directory';
import { teamDirectoryTableResource } from './resources/team-directory-table';

const TeamsDirectoryLoadable = Loadable<RouteContext, any>({
	loader: () => import(/* webpackChunkName: "teamsDirectory-view" */ './components/TeamDirectory'),
	loading: () => null,
});

teamsDirectoryRoute.component = TeamsDirectoryLoadable;
teamsDirectoryRoute.resources = [
	teamDirectoryResource,
	tqlExplainerResource,
	teamDirectoryTableResource,
	cleanUpTeamsSkillNudgeResource,
];
export const teamsDirectoryRouterRoute = teamsDirectoryRoute;
